import '../utilities/css.js';
import '../doubleclick/css.js';
import '../draggable/css.js';
import '../resizable/css.js';
import '../sortable/css.js';
import '../docker/css.js';
import './window.scss';